import { useSelector } from 'react-redux'
import Immutable from 'immutable'
import Auth from '../../../lib/commons/auth'
import { AllState } from '../../../store'
import { FunctionLayer } from '../../../store/functionLayer'
import { useProjectPrivateContext } from '../../context/projectContext'
import { projectPrivate } from '../../higher-order-components/projectPrivate'
import { PageProps } from '..'
import { useSelectColumnOptions } from './hooks/selectColumnOptions'
import { UserProps } from '../../../lib/functions/user'
import { useEntityExtension } from '../../hooks/useEntityExtension'
import { useWbsItemAdditionalPropertiesOfBaseWbsItemTypes } from '../../hooks/useWbsItemAdditionalProperties'
import { WbsItemSearchV2Initializer } from './WbsItemSearchV2'

const WbsItemSearch = projectPrivate(({ uuid }: PageProps) => {
  const { project } = useProjectPrivateContext()
  const functionLayer = useSelector<
    AllState,
    Immutable.Map<number, FunctionLayer>
  >(state => state.functionLayer.layers)
  const selectColumnOptions = useSelectColumnOptions(project.uuid)

  const loginUser: UserProps | undefined = Auth.getCurrentTenant()?.user
  const { extensions } = useEntityExtension(uuid, project?.uuid)

  const {
    fetched: fetchedWbsItemAdditionalProperties,
    wbsItemAdditionalProperties,
  } = useWbsItemAdditionalPropertiesOfBaseWbsItemTypes()

  if (
    !project ||
    !selectColumnOptions ||
    !loginUser?.uuid ||
    !extensions ||
    !fetchedWbsItemAdditionalProperties
  ) {
    return <></>
  }

  return (
    <WbsItemSearchV2Initializer
      applicationFunctionUuid={uuid}
      projectUuid={project.uuid}
      functionLayer={functionLayer}
      selectColumnOptions={selectColumnOptions}
      loginUserUuid={loginUser.uuid}
      extensions={extensions}
      wbsItemAdditionalProperties={wbsItemAdditionalProperties!}
    />
  )
})

export default WbsItemSearch
